import React from 'react';
import styled from 'styled-components';
import { SvgProps, Svg } from '../Svg';

const IconContainer = styled.div<{ size?: number }>`
  position: relative;
  width: ${({ size }) => size || 145}px;
  height: ${({ size }) => size || 145}px;
`;

const LoaderComponent = styled.div<{ showloader?: boolean; size?: number }>`
  display: ${({ showloader }) => !showloader && 'none'};
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  border: 5px solid #f7f7f8;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 2s linear infinite;
  border-top: 5px solid #3b3c43;
  border-radius: 50%;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
`;

const StredaIcon = styled(Svg)`
  position: absolute;
  display: inline-block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
`;

interface IStredaRoundIcon extends SvgProps {
  loading?: boolean;
  loaderSize?: number;
}

const Icon: React.FC<IStredaRoundIcon> = props => {
  const { loading, width, height, loaderSize } = props;
  return (
    <IconContainer size={loaderSize}>
      <LoaderComponent showloader={loading} className="loaderCircle" />
      <StredaIcon
        width={width || 104}
        height={height || 104}
        viewBox="0 0 104 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M29.6669 66.276L13.8494 34.6671L31.1843 34.6671L46.1976 64.6865C46.9197 66.1309 47.2956 67.7235 47.2956 69.3382C47.2956 70.953 46.9197 72.5455 46.1976 73.9899L32.994 100.404C33.9645 100.785 34.943 101.133 35.943 101.458C40.5256 92.3 45.1056 83.1423 49.6828 73.9845C50.4049 72.5402 50.7808 70.9476 50.7808 69.3329C50.7808 67.7181 50.4049 66.1256 49.6828 64.6812C44.6784 54.6747 39.674 44.6682 34.6696 34.6617L51.9965 -4.54568e-06C41.2162 0.00285113 30.7033 3.35463 21.9116 9.59175C13.1199 15.8289 6.48402 24.6431 2.92172 34.8154C-0.640586 44.9876 -0.953259 56.0152 2.02695 66.3729C5.00715 76.7305 11.133 85.9064 19.5571 92.6315L29.6803 72.3898C30.153 71.4396 30.3978 70.3925 30.3955 69.3313C30.3932 68.2701 30.1437 67.2241 29.6669 66.276Z"
          fill="#3B3C43"
        />
        <path
          d="M74.323 37.7293C79.5937 48.2719 84.8662 58.8073 90.1405 69.3355L72.7948 69.3355C67.7904 59.329 62.786 49.3225 57.7815 39.3161C57.0595 37.8717 56.6836 36.2791 56.6836 34.6644C56.6836 33.0497 57.0595 31.4571 57.7815 30.0127C62.1872 21.207 66.5911 12.4013 70.9932 3.5956C70.0227 3.21499 69.0397 2.86387 68.0442 2.54223C63.4723 11.7017 58.8959 20.8621 54.3151 30.0234C53.593 31.4678 53.2171 33.0604 53.2171 34.6751C53.2171 36.2898 53.593 37.8824 54.3151 39.3268C59.3195 49.3333 64.3239 59.3398 69.3284 69.3462C63.5483 80.8966 57.7673 92.4478 51.9854 104C62.7668 104.001 73.282 100.652 82.0764 94.4167C90.8708 88.1813 97.5096 79.3677 101.074 69.1951C104.639 59.0225 104.954 47.9938 101.975 37.6345C98.9961 27.2753 92.8707 18.0976 84.4462 11.3712L74.323 31.6129C73.8482 32.5624 73.601 33.6095 73.601 34.6711C73.601 35.7327 73.8482 36.7797 74.323 37.7293Z"
          fill="#3B3C43"
        />
      </StredaIcon>
    </IconContainer>
  );
};

export default Icon;
